import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';

import { GET, POST, PUT, DELETE, newFetch } from '../../../../../helpers/fetch';
import ToastUtil from '../../../../../components/ToastNotification/ToastUtil';
import AlertService from '../../../../../components/SweetAlert';

const Actions = ({ history }) => {
  const [SEVs, setSEVs] = useState([]);
  const [actions, setActions] = useState([]);
  const [oldActions, setOldActions] = useState([]);
  const [newActions, setNewActions] = useState([]);

  useEffect(() => {
    const fetchSEVs = async () => {
      let api_path = '/tt/severity';
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setSEVs(response.data);
      }
    };

    const fetchActions = async () => {
      let api_path = '/tt/action';
      let response = await newFetch(GET, api_path);

      if (response.success) {
        setActions(response.data);
        setOldActions(JSON.parse(JSON.stringify(response.data)));
      }
    };

    fetchSEVs();
    fetchActions();
  }, []);

  const addNewAction = () => {
    var newID = '';

    if (newActions.length > 0) {
      const lastNewAction = [...newActions].pop();
      newID = lastNewAction.id + 1;
    } else {
      const lastOldAction = [...oldActions].pop();
      newID = lastOldAction ? lastOldAction.id + 1 : 1;
    }

    setNewActions([
      ...newActions,
      {
        id: newID,
        name: '',
        sev_id: '',
        // is_enabled: true
      },
    ]);
  };

  const updateNewActionName = (index, e) => {
    let clone = [...newActions];
    clone[index].name = e.target.value;
    setNewActions(clone);
  };

  const updateNewActionLevel = (index, e) => {
    let clone = [...newActions];
    clone[index].sev_id = e.target.value;
    setNewActions(clone);
  };

  const deleteNewAction = (index) => {
    setNewActions([...newActions].filter((action, i) => i !== index));
  };

  const enableDisableNewAction = (index) => {
    let clone = [...newActions];
    clone[index].is_enabled = !clone[index].is_enabled;
    setNewActions(clone);
  };

  const updateOldActionName = (index, e) => {
    let clone = [...oldActions];
    clone[index].name = e.target.value;
    setOldActions(clone);
  };

  const updateOldActionLevel = (index, e) => {
    let clone = [...oldActions];
    clone[index].sev_id = e.target.value;
    setOldActions(clone);
  };

  // const deleteOldAction = async id => {
  //     if (await AlertService.confirm("", 'Are you sure you want to delete this action?')) {
  //         let api_path = `/tt/action/${id}`
  //         let response = await newFetch(DELETE, api_path)

  //         ToastUtil.success(response.message)
  //         response.success && window.location.reload()
  //     }
  // }

  const enableDisableOldAction = (index) => {};

  const discardActionHandler = () => {
    setOldActions(actions);
    setNewActions([]);
  };

  const submitActionHandler = async (e) => {
    e.preventDefault();

    if (
      await AlertService.confirm('', 'Are you sure you want to update Actions?')
    ) {
      let api_path = `/tt/action`;

      // // update old actions
      if (oldActions.length > 0) {
        let update_data = {
          actions: oldActions.map((action) => ({
            id: action.id,
            name: action.name,
            sev_id: action.sev_id,
          })),
        };
        let update_response = await newFetch(PUT, api_path, update_data);

        ToastUtil.success(update_response.message);

        update_response.success &&
          newActions.length <= 0 &&
          window.location.reload();
      }

      // // create new actions
      if (newActions.length > 0) {
        let create_data = {
          actions: newActions.map((action) => ({
            name: action.name,
            sev_id: action.sev_id,
          })),
        };
        let create_response = await newFetch(POST, api_path, create_data);

        ToastUtil.success(create_response.message);
        create_response.success && window.location.reload();
      }
    }
  };

  return (
    <form
      onSubmit={(e) => submitActionHandler(e)}
      className="d-flex flex-column"
    >
      <div className="p-4 d-flex flex-column">
        <h5 className="mb-4 pb-2">Actions</h5>
        <div className="row border-bottom mb-2 pb-2 mx-1">
          <div className="col-1 p-0 fw-bold">ID</div>
          <div className="col-7 p-0 fw-bold">Actions</div>
          <div className="col-3 p-0 text-center fw-bold">SEV Level</div>
          {/* <div className="col-1 p-0 text-center fw-bold">Enabled</div> */}
          <div className="col-1"></div>
        </div>
        {oldActions.map((action, index) => (
          <div key={index} className="row py-2">
            <div className="col-1">{action.id}</div>
            <div className="col-7">
              <input
                type="text"
                className="form-control adjust-fs"
                value={action.name}
                onChange={(e) => updateOldActionName(index, e)}
              />
            </div>
            <div className="col-3">
              {SEVs && SEVs.length > 0 && (
                <input
                  type="number"
                  min="0"
                  max={[...SEVs].pop().id}
                  className="form-control text-center adjust-fs"
                  value={action.sev_id}
                  onChange={(e) => updateOldActionLevel(index, e)}
                />
              )}
            </div>
            {/* <div className="col-1 text-center" style={{ cursor: 'pointer' }} onClick={() => enableDisableOldAction(index)}><i className="fas fa-times text-danger pt-2"></i></div> */}
            {/* <div className="col-1 text-center" style={{ cursor: 'pointer' }} onClick={() => deleteOldAction(action.id)}><i className="fas fa-times text-danger pt-2"></i></div> */}
            <div className="col-1 text-center"></div>
          </div>
        ))}
        {newActions.map((action, index) => (
          <div key={index} className="row py-2">
            <div className="col-1 text-center">{action.id}</div>
            <div className="col-7">
              <input
                type="text"
                className="form-control adjust-fs"
                value={action.name}
                onChange={(e) => updateNewActionName(index, e)}
              />
            </div>
            <div className="col-3">
              {SEVs && SEVs.length > 0 && (
                <input
                  type="number"
                  min="0"
                  max={[...SEVs].pop().id}
                  className="form-control text-center adjust-fs"
                  value={action.sev_id}
                  onChange={(e) => updateNewActionLevel(index, e)}
                />
              )}
            </div>
            {/* <div className="col-1 text-center" style={{ cursor: 'pointer' }} onClick={() => enableDisableNewAction(index)}>{action.is_enabled ? <i className="fas fa-check text-success pt-2"></i> : <i className="fas fa-times text-danger pt-2"></i>}</div> */}
            <div
              className="col-1 text-center"
              style={{ cursor: 'pointer' }}
              onClick={() => deleteNewAction(index)}
            >
              <i className="fas fa-trash pt-2"></i>
            </div>
          </div>
        ))}

        <button
          type="button"
          className="btn btn-block btn-outline-brand text-start mt-2 p-3 adjust-fs adjust-shadow"
          onClick={() => addNewAction()}
        >
          <i className="fas fa-plus me-2" /> Add New Action
        </button>
      </div>
      <div
        style={{
          height: '4.5rem',
        }}
        className="border-top bg-white d-flex align-items-center justify-content-end mt-auto p-4"
      >
        <button
          type="button"
          onClick={discardActionHandler}
          className="btn btn-outline-brand adjust-fs adjust-shadow"
          style={{ width: '12rem' }}
        >
          Discard
        </button>
        <button
          type="submit"
          className="btn btn-brand ms-3 adjust-fs adjust-shadow"
          style={{ width: '12rem' }}
        >
          Save changes
        </button>
      </div>
    </form>
  );
};

export default withRouter(Actions);
